import api from '@api'
import { setInsightsMthlyDepositData } from './index.js'

export const getInsightsBankMthlyDepositData = bid => async (dispatch, getState) => {
  try {
    const res = await api.get(`/v1/businesses/${bid}/bank_feeds/bank_connections/monthly_adb_deposits`)
    await dispatch(setInsightsMthlyDepositData(res.data))
    //return res.data
  } catch (error) {
    console.error(error)
  }
}

export default getInsightsBankMthlyDepositData
